import React from "react";
import { Conversation } from "../types";

interface ChatHeaderProps {
  conversation: Conversation;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({conversation}) => {

  return (
    <div className="nav border-light bg-white d-flex">
      {conversation?.title && (
        <div className="p-3 d-flex align-items-center">
          {conversation?.data && conversation.data?.country_code && (
            <span className={`me-1 fi fi-${conversation.data.country_code.toLocaleLowerCase()}`}></span>
          )}
          <h2 className="fw-bold h6 m-0">{conversation.title.slice(0, 50)}...</h2>
        </div>
      )}

      {/* <div className="btn-group border rounded-4"  role="group">
        <button
          type="button"
          className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 py-1`}
          onClick={() =>{return false}}
        >
          <span>Dest.</span>
        </button>
        <button
          type="button"
          className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 py-1 `}
          onClick={() =>{return false}}
        >
          <span>Dates</span>
        </button>
        <button
          type="button"
          className={`d-flex align-items-center btn btn-outline-primary border-0 rounded-4 py-1 `}
          onClick={() =>{return false}}
        >
          <span>Pax</span>
        </button>
      </div> */}

    </div>
  );
};

export default ChatHeader;
